import React, { useEffect, useState, useContext } from "react";
import "./VdFeatures.css";

import feature1 from "../../../../assets/images/voyahdream/exterior/ext2.jpg";
import feature2 from "../../../../assets/images/voyahdream/interior/int3.jpg";
import feature3 from "../../../../assets/images/voyahdream/accessories/acc3.jpg";
import feature4 from "../../../../assets/images/voyahdream/interior/int4.jpg";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const HARDCODED_MEDIA = [feature1, feature2, feature3, feature4];

const buildFeatureItems = (data) => {
  if (!data) return [];

  const items = [];
  for (let n = 1; n <= 20; n += 1) {
    const title = data[`feature_${n}_title`];
    if (!title) break;

    items.push({
      title,
      media: HARDCODED_MEDIA[(n - 1) % HARDCODED_MEDIA.length],
    });
  }

  return items;
};

const VdFeatures = () => {
  const { currentLang } = useContext(LanguageContext);

  const [features, setFeatures] = useState(null);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFeatures = async () => {
      try {
        setLoading(true);

        const response = await getPageContent("voyahdream", currentLang);
        const data = response.sections?.features;
        const items = buildFeatureItems(data);

        setFeatures({
          title: data?.features_title || "Features",
          items,
        });
      } catch (err) {
        console.error("Failed to load Voyah Dream features", err);
      } finally {
        setLoading(false);
      }
    };

    loadFeatures();
  }, [currentLang]);

  if (loading || !features || features.items.length === 0) return null;

  const current = features.items[active];

  return (
    <section className="vd-features">
      <h2 className="vd-features-title">{features.title}</h2>
      <span className="vd-features-line" />

      <div className="vd-features-tabs">
        {features.items.map((item, index) => (
          <div
            key={index}
            className={`vd-feature-tab ${active === index ? "active" : ""}`}
            onClick={() => setActive(index)}
          >
            <p>{item.title}</p>
          </div>
        ))}
      </div>

      <div className="vd-features-media">
        <img
          key={active}
          src={current.media}
          alt={current.title}
          className="vd-features-media-image"
        />
      </div>
    </section>
  );
};

export default VdFeatures;
